import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Sidebar } from '../components/sidebar/sidebar.component';

export enum SidebarState {
    Open = 'open',
    Closed = 'closed',
}

export type SidebarStateChangedEvent = {
    sidebar: Sidebar;
    state: SidebarState;
};

@Injectable({
    providedIn: 'root',
})
export class SidebarService {
    private stateChangeSubject = new Subject<SidebarStateChangedEvent>();
    private state$ = this.stateChangeSubject.asObservable();
    private currentState: SidebarState = SidebarState.Closed;

    public notifyStateChanged(sidebar: Sidebar, state: SidebarState): void {
        this.currentState = state;
        this.stateChangeSubject.next({
            sidebar: sidebar,
            state: state,
        });
    }

    public getCurrentState(): SidebarState {
        return this.currentState;
    }

    public onStateChanged(): Observable<SidebarStateChangedEvent> {
        return this.state$;
    }
}
